import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PreviousNextStop from './previous-next-stop';
import LocationsMapbox from '../components/locationsMap';
import DaysNightPanel from './dates-nights-panel';
import AccommodationPanel from './accommodation-panel';
import DeleteSectorPanel from './delete-sector-panel';
import { bindActionCreators } from 'redux';
import { ToggleSlidingPanel } from '../../../../actions/utils';
import { itineraryListData } from '../../../../helpers/itineraryHelper';
import { get } from '../../../../helpers/objectHelper';
import MeetingPointPanel from './meeting-point-panel';
import { DeleteHotel, SetHotelMeta } from '../../../../actions/hotel';
import AccommodationTextPanel from './accommodation-text-panel';


class ItinerarySlidePanel extends PureComponent {
   
   constructor(props){
      super(props);

      this.state = {
        contentPanelName:"main",
        currentStop:null,
        currentStopText:null,
        totalStops:null,
        ready:false
      }

      this.onPreviousClicked = this.onPreviousClicked.bind(this);
      this.onNextClicked = this.onNextClicked.bind(this);
      this.closePanel = this.closePanel.bind(this);
   }

   componentDidMount(){

      //Init mapbox
      this.locationMapbox = new LocationsMapbox();
      this.locationMapbox.initMap();

      document.body.addEventListener('ITININERARY_SECTOR_CLICK', e => this.openPanel(e, e.detail) );

  
    //  //FOR TESTING ONLY
    //  const slidingPanel = document.querySelector(`[data-slide-panel=${this.state.contentPanelName}]`);
    //  slidingPanel.classList.add('js-panel--is-visible');
     //END OF TESTING
   } 
   
   componentWillUnmount(){
      document.body.removeEventListener('ITININERARY_SECTOR_CLICK', this.openPanel);
      this.setState({currentStop:0, currentStopText:0, totalStops:0, ready:false});
   }

   componentDidUpdate(prevProps, prevState){

      if(this.state.currentStop !== prevState.currentStop){
        this.updateMapboxCoordinates();
      }

      if(this.props.hotel !== prevProps.hotel){
        this.updateHotelMapBox();
      }
   }

   openPanel(e, detailsObj){


      const { contentPanelName } = this.state;
      const { _itinerary } = this.props;
      const { id, index } = detailsObj;
      const _totalStops = _itinerary !== undefined ? _itinerary.length : 0;

      //FIX - check for duplicate null id's 
      const _index = id !== null ? _itinerary.findIndex(item => item.id === id) : index;

      e.preventDefault();

      const slidingPanel = document.querySelector(`[data-slide-panel=${contentPanelName}]`);

      //Open sliding panel on trigger button
      slidingPanel.classList.add('js-panel--is-visible');

      //Fix - remove double scrollbar 
      document.querySelector('body').classList.add('overflow-hidden');
      
      //Add close event listener
      slidingPanel.addEventListener('click', this.closePanel);


      //Set current stop, text, totalstop and map active state
      this.setState({currentStop: _index, currentStopText:_index+1, totalStops:_totalStops, ready:true}, ()=>{
        this.updateMapboxCoordinates();
      });
 
      
   }


   closePanel(e){

      const { contentPanelName } = this.state;
      const { ToggleSlidingPanel, DeleteHotel } = this.props;

      if(e !== null){ 
        e.preventDefault();

        //close panel on 'close button' or outside panel
        if(e.target.classList.contains('js-close-panel') || e.target.dataset.slidePanel === contentPanelName){
          document.querySelector(`[data-slide-panel=${contentPanelName}]`).classList.remove('js-panel--is-visible');
          document.querySelector('body').classList.remove('overflow-hidden');
          setTimeout(() => {
            ToggleSlidingPanel(false, false, false);
            DeleteHotel();
            this.setState({ready:false});
          }, 300);
        }

      }else{
   
        document.querySelector(`[data-slide-panel=${contentPanelName}]`).classList.remove('js-panel--is-visible');
        document.querySelector('body').classList.remove('overflow-hidden');
        setTimeout(() => {
          ToggleSlidingPanel(false, false, false);
          DeleteHotel();
          this.setState({ready:false});
        }, 300);
       
      }


   }

   onPreviousClicked(){
    const { currentStopText, currentStop } = this.state;
    if(currentStopText > 1) this.setState({currentStopText: currentStopText - 1, currentStop: currentStop - 1 });
   }

   onNextClicked(){
    const { currentStopText, totalStops, currentStop } = this.state;
    if(currentStopText < totalStops) this.setState({currentStopText: currentStopText + 1, currentStop: currentStop + 1});
   }

   updateMapboxCoordinates(){
      const { currentStop } = this.state;
      const { _itinerary  } = this.props;
      const _pickupLocation = get([currentStop, 'cityInfo', 'pickUpDropOff'], _itinerary, null);
      const _reservationType = get([currentStop, 'accommodation', 'reservations', 0, 'type'], _itinerary, null);
    
      if(_pickupLocation !== null && _reservationType !== 'hotel') this.locationMapbox.updateCoordinates([_pickupLocation.lon, _pickupLocation.lat]);
   }

   updateHotelMapBox(forceUpdate, removeMarker){

    const { currentStop } = this.state;
    const { _itinerary, SetHotelMeta } = this.props;
    const _pickupLocation = get([currentStop, 'cityInfo', 'pickUpDropOff'], _itinerary, null);
    const _reservationType = get([currentStop, 'accommodation', 'reservations', 0, 'type'], _itinerary, null);
    const _reservationLocation = get([currentStop, 'accommodation', 'reservations', 0, 'location'], _itinerary, null);

    if(forceUpdate && removeMarker){
      this.locationMapbox.removeAccommodationMarker(_pickupLocation);
    }

    if(forceUpdate && !removeMarker && _reservationType === 'hotel'){
      this.locationMapbox.getAccommodationLocation("hotel", _pickupLocation, _reservationLocation).then(response => SetHotelMeta(response));
    }

   }


   render(){ 

      const { contentPanelName, currentStop, totalStops, currentStopText, ready } = this.state;
      const { _itinerary, currentBooking:{status}, share } = this.props;
      const { 
        type:_type,
        totalStops:_totalStops,
        cityOrProductName:_cityOrProductName,
        hasNights:_hasNights,
        hostelAccommodation:_hostelAccommodation,
      } = itineraryListData(currentStop, _itinerary); 

      // return (
      //   <div className="js-panel js-panel--from-right" data-slide-panel={contentPanelName}>
      //   <div className="js-panel__container">
      //     <div className="js-panel__content">
      //       <div className="clearfix">
      //           <div className="col col-12 px2">
      //               <button className="close-button js-close-panel" type="button"></button>
      //           </div>
      //         </div>
      //       <p>Testing</p>
      //     </div>
      //     </div>
      //     </div>
      // )
      
      return (
        <div className="js-panel js-panel--from-right" data-slide-panel={contentPanelName}>
          <div className="js-panel__container">
            <div className="js-panel__content">
                <div className="clearfix">
                    <div className="col col-12 px2">
                        <button className="close-button js-close-panel" type="button"></button>
                    </div>

                    <div className="col col-12 px3 margin-b-80">
                      { ready && <PreviousNextStop currentStop={currentStopText} totalStops={_totalStops} onNextClicked={this.onNextClicked} onPreviousClicked={this.onPreviousClicked}/>}
                    </div>

                </div>
                <div className="sliding-panel-info margin-b-100">
                    <div className="clearfix margin-b-70">
                      <div className="col col-12 px2">
                        <div className="sliding-panel-accommodation">
                          <div className="clearfix">
                            <div className="col col-12 md-col-7 px2">
                              <h2 className="margin-b-50">{_cityOrProductName}</h2>

                              { ready && <DaysNightPanel currentStop={currentStop} totalStops={_totalStops} share={share} />}

                              <div className="divider-line margin-b-30"></div>

                              { ready && <AccommodationTextPanel currentStop={currentStop} />}
        
                              <div className="divider-line margin-b-30"></div>

                              { ready && <MeetingPointPanel currentStop={currentStop} totalStops={_totalStops}/>}
    
                              <div className="clearfix">
                                <div className="col col-12 margin-b-40">
                                  <div id='location-map'></div>
                                </div>
                              </div>

                              { ((currentStop > 0 && currentStop === totalStops-1) && (status !== "confirmed" && status !== "checkout" && !share) && ready ) && <DeleteSectorPanel currentStop={currentStop} closeSlidePanel={() => {this.closePanel(null)} } />}

                            </div>


                            {
                              (_type !== "product" && _hasNights && _hostelAccommodation && !share) &&           
                              <div className="col col-12 md-col-5 px2">
                                  { ready && <AccommodationPanel data={_itinerary[currentStop]} currentStop={currentStop} updateMap={() => this.updateHotelMapBox(true, false)} removeMap={() => this.updateHotelMapBox(true, true)}  />}
                              </div>
                            }


                          </div>

                         <div className="clearfix">
                            <div className="col col-12 px2 margin-t-80">
                              { ready && <PreviousNextStop currentStop={currentStopText} totalStops={_totalStops} onNextClicked={this.onNextClicked} onPreviousClicked={this.onPreviousClicked}/> }
                            </div>
                          </div>         

                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div> 
      </div>
      )

   }
}


const mapStateToProps = state => {
    return{
      currentBooking:state.currentBooking,
      _itinerary:state.currentBooking.filteredItinerary,
      hotel:state.hotel.sector[0]
    }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
      ToggleSlidingPanel,
      DeleteHotel,
      SetHotelMeta
  }, dispatch);
}
  
export default connect(mapStateToProps, mapDispatchToProps)(ItinerarySlidePanel); 
  